import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ChevronLeft, ChevronRight } from "lucide-react"; // or any icon library

// Custom Arrows
const NextArrow = ({ onClick }) => (
    <div
        className="slick-arrow slick-next"
        onClick={onClick}
        style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            zIndex: 2,
        }}
    >
        <ChevronRight size={28} color="#333" />
    </div>
);

const PrevArrow = ({ onClick }) => (
    <div
        className="slick-arrow slick-prev"
        onClick={onClick}
        style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            zIndex: 2,
        }}
    >
        <ChevronLeft size={28} color="#333" />
    </div>
);
const LoginSlide = () => {
    const settings = {
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        // nextArrow: <NextArrow />,
        // prevArrow: <PrevArrow />,

    };
    return (
        <>
            <div
                className="col-md-12 d-flex m-0" style={{ backgroundColor: "#F8F8F8", borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px" }}
            >
                <Slider {...settings} className="w-100 border-none" >
                    <div
                        className="d-flex flex-column justify-content-center align-items-center text-center w-100 h-100 pb-40 pt-40"
                    >
                        <img
                            src="/assets/images/login1.png"
                            alt="Slide 1"
                            style={{ maxHeight: "300px", objectFit: "contain", marginBottom: "20px" }}
                        />
                        <h6 className="fw-bold mb-1">Tired of Delays, Calls &</h6>
                        <h6 className="fw-bold mb-2">Unreliable Vendors?</h6>
                        <p className="text-muted small m-0">We get it. Running a project is hard</p>
                        <p className="text-muted small m-0">when your materials are late,</p>
                        <p className="text-muted small m-0">overpriced, or unavailable.</p>
                    </div>

                    <div
                        className="d-flex flex-column justify-content-center align-items-center text-center w-100 h-100 pb-40 pt-40"
                    >
                        <img
                            src="/assets/images/login2.png"
                            alt="Slide 2"
                            style={{ maxHeight: "300px", objectFit: "contain", marginBottom: "20px" }}
                        />
                        <h6 className="fw-bold mb-1">PTC Delivers the Right</h6>
                        <h6 className="fw-bold mb-2">Materials. On Time</h6>
                        <p className="text-muted small m-0">Dealer, contractor, or homeowner</p>
                        <p className="text-muted small m-0">PTC delivers the right materials on</p>
                        <p className="text-muted small m-0">time at the best prices.</p>
                    </div>

                    <div
                        className="d-flex flex-column justify-content-center align-items-center text-center w-100 h-100 pb-40 pt-40"
                    >
                        <img
                            src="/assets/images/login3.png"
                            alt="Slide 3"
                            style={{ maxHeight: "300px", objectFit: "contain", marginBottom: "20px" }}
                        />
                        <h6 className="fw-bold mb-1">Smart Orders.</h6>
                        <h6 className="fw-bold mb-2">Simple Process.</h6>
                        <p className="text-muted small m-0">PTC is South India's trusted</p>
                        <p className="text-muted small m-0">supplier - built for smart orders,</p>
                        <p className="text-muted small m-0">designed for a simple process.</p>
                    </div>
                </Slider>
            </div></>
    )
}

export default LoginSlide